import React, { useState, useEffect } from 'react';
import { X, CheckCircle, Users, TrendingUp } from 'lucide-react';

const SocialProofNotification = () => {
  const [currentNotification, setCurrentNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  // Demo notifications - replace with real data from backend later
  const notifications = [
    {
      type: 'booking',
      name: 'Priya S.',
      location: 'Mumbai',
      action: 'just booked a consultation for Canada',
      time: '2 minutes ago',
      icon: CheckCircle,
      color: 'text-green-600'
    },
    {
      type: 'booking',
      name: 'Rahul M.',
      location: 'Delhi',
      action: 'just got visa approved for Australia',
      time: '5 minutes ago',
      icon: CheckCircle,
      color: 'text-green-600'
    },
    {
      type: 'booking',
      name: 'Sneha K.',
      location: 'Bangalore',
      action: 'just booked a consultation for UK',
      time: '8 minutes ago',
      icon: CheckCircle,
      color: 'text-green-600'
    },
    {
      type: 'stats',
      message: '127 students consulted with us this week',
      icon: Users,
      color: 'text-blue-600'
    },
    {
      type: 'booking',
      name: 'Amit P.',
      location: 'Pune',
      action: 'just started their USA visa process',
      time: '12 minutes ago',
      icon: CheckCircle,
      color: 'text-green-600'
    },
    {
      type: 'stats',
      message: '95% visa success rate in 2024',
      icon: TrendingUp,
      color: 'text-orange-600'
    },
    {
      type: 'booking',
      name: 'Divya R.',
      location: 'Hyderabad',
      action: 'just booked a consultation for Germany',
      time: '15 minutes ago',
      icon: CheckCircle,
      color: 'text-green-600'
    }
  ];

  useEffect(() => {
    // Show first notification after 5 seconds
    const initialDelay = setTimeout(() => {
      showNextNotification();
    }, 5000);

    return () => clearTimeout(initialDelay);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const showNextNotification = () => {
    const randomNotification = notifications[Math.floor(Math.random() * notifications.length)];
    setCurrentNotification(randomNotification);
    setIsVisible(true);

    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);

    // Show next notification after 15-25 seconds
    setTimeout(() => {
      showNextNotification();
    }, Math.random() * 10000 + 15000);
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!currentNotification || !isVisible) return null;

  const Icon = currentNotification.icon;

  return (
    <div 
      className={`fixed bottom-6 left-6 z-50 transform transition-all duration-500 ${
        isVisible ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
      }`}
      style={{ maxWidth: '380px' }}
    >
      <div className="bg-white rounded-lg shadow-2xl border border-gray-200 p-4 pr-12 relative">
        {/* Close button */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X size={16} />
        </button>

        <div className="flex items-start gap-3">
          {/* Icon */}
          <div className={`${currentNotification.color} mt-1`}>
            <Icon size={20} />
          </div>

          {/* Content */}
          <div className="flex-1">
            {currentNotification.type === 'booking' ? (
              <>
                <div className="font-semibold text-gray-900 text-sm">
                  {currentNotification.name} 
                  <span className="text-gray-500 font-normal ml-1">
                    from {currentNotification.location}
                  </span>
                </div>
                <div className="text-gray-600 text-sm mt-0.5">
                  {currentNotification.action}
                </div>
                <div className="text-gray-400 text-xs mt-1">
                  {currentNotification.time}
                </div>
              </>
            ) : (
              <div className="font-medium text-gray-900 text-sm">
                {currentNotification.message}
              </div>
            )}
          </div>
        </div>

        {/* Pulse indicator */}
        <div className="absolute -top-1 -left-1">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default SocialProofNotification;
